import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class FormationsSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            // autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            freeScroll: true,
            cellSelector: '.formation-card',
            cellAlign: 'left'
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.formation-card');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
            this._setEqualHeight();
        }
    }

	_createSlider() {
        new Flickity(this.$el[0], this.options);
    }

    _setEqualHeight() {
		let maxHeight = 0;
		this.$slides = this.$el.find(".formation-card");

		this.$slides.css("height", "auto");

		this.$slides.each(function () {
			maxHeight = Math.max(maxHeight, $(this).outerHeight());
		});

		this.$slides.css("height", maxHeight);
	}
}

export default FormationsSlider;
